<div class="lei-content">
  <h3>Legal Entity Information...</h3>
  <p><strong>ID:</strong> {{ entityId }}</p>
  <p class="placeholder">Details placeholder for {{ entityId }}.</p>
</div>
